<script setup lang="ts">
</script>

<script lang="ts">
import {defineComponent, PropType} from 'vue'
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";

export default defineComponent({
    name: 'CardInfo',

    props: {
        pass: {
            type: Object as PropType<PassProperties>,
            required: true,
        },
    },

    computed: {
        discountPrice(): number | null
        {
            if (this.pass.code === 'WHITE_PASS') {
                return 14999
            }

            return this.pass.discountPrice
        },

        basicPrice(): number | null
        {
            if (this.pass.code === 'WHITE_PASS') {
                return 20000
            }

            return this.pass.basicPrice
        },
    }
})
</script>

<template>
    <div class="cardInfo noselect">
        <h4
            :class="{
                white_pass: pass.code === 'WHITE_PASS',
            }"
            :style="{
                color: pass.labelColor,
            }">
            {{ pass.name }}
        </h4>

        <div
            class="description"
        >
            <div class="d-flex flex-row justify-content-center align-items-center">
                <div class="gcPriceBox d-flex flex-row justify-content-center align-items-center">
                    <img alt="Галакоин, галакоины" class="icon" :src="`/img/page/landing/registration/icon/galacoin.png`">

                    <div class="d-flex flex-column text-nowrap">
                        <span class="amount text-nowrap">{{ pass.galacoinAmount }}</span>
                        <span class="currency">галакоинов</span>
                    </div>
                </div>
            </div>

            <div class="d-flex flex-row justify-content-center align-items-center">
                <ul>
                    <li>
                        <img :alt="pass.avatar.name" class="bonusIcon avatar" :src="`/img/page/landing/registration/avatar/${pass.avatar.image}/face.png`">
                        <div class="bonus avatar">
                            <div class="type">Аватар</div>
                            <div class="name">«{{ pass.avatar.name }}»</div>
                        </div>
                    </li>

                    <li>
                        <img :alt="pass.frame.name" class="bonusIcon" :src="`/img/faceframes/${pass.frame.image}`">
                        <div class="bonus">
                            <div class="type">Рамка</div>
                            <div class="name">«{{ pass.frame.name }}»</div>
                        </div>
                    </li>

                    <li>
                        <img
                            :alt="pass.ship.name"
                            class="bonusIcon"
                            :class="{
                                flipped: pass.code === 'WHITE_PASS'
                            }"
                            :src="`/img/page/landing/registration/ship/${pass.ship.image}`"
                        >
                        <div class="bonus">
                            <div class="type">Голограмма</div>
                            <div class="name">«{{ pass.ship.name }}»</div>
                        </div>
                    </li>

                    <li>
                        <img :alt="pass.container.name" class="bonusIcon" :src="`/img/page/landing/registration/container/${pass.container.image}.png`">
                        <div class="bonus">
                            <div class="type">Контейнер</div>
                            <div class="name">{{ pass.container.name }}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div
            class="gcPriceBox priceBox d-flex flex-row justify-content-center align-items-center"
            :class="{
                playersChoice: pass.isPlayersChoice,
            }"
        >
            <div class="d-flex flex-row gap-3">
                <template v-if="discountPrice !== null">
                    <span class="amount stroke">{{ basicPrice.toLocaleString('ru').replace(/\u00A0/g, ' ') }} ₽</span>
                    <span class="amount discount">{{ discountPrice.toLocaleString('ru').replace(/\u00A0/g, ' ') }} ₽</span>
                </template>

                <template v-else>
                    <span class="amount">{{ pass.basicPrice.toLocaleString('ru').replace(/\u00A0/g, ' ') }} ₽</span>
                </template>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.cardInfo {
    position: relative;
    display: flex;
    height: 100%;
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;

    z-index: 900;
    align-items: flex-end;
    padding: 15px 0 0 0;
    gap: 10px;
    overflow: hidden;
}

h4 {
    width: 100%;
    line-height: 1;
    text-align: center;
    text-shadow: 2px 2px 5px black;
    background: rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.6);
    padding: 2px 0 3px 0;
    margin: 0 0 auto 0;
    font-size: 20px;

    &.white_pass {
        padding-top: 8px;
        font-family: Furore;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.0);

        font-size: 26px;
        background: linear-gradient(135deg,
            #f0d788 0%,
            #c0a16b 25%,
            #f0d687 45%,
            #bd9e6b 55%,
            #ebd288 75%,
            #bd9e6b 100%
        );
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent !important;
        text-shadow: 0 2px 3px rgba(0,0,0,0.2);
    }
}

.gcPriceBox {
    gap: 8px;
    padding: 0 5px 0 5px;

    .icon {
        width: 40px;
        height: 40px;
    }

    .amount {
        font-size: 28px;
        color: #a8f5ff;
        line-height: 1;
        text-shadow: 2px 2px 5px black;
    }

    .currency {
        color: #00ffff;
        font-size: 14px;
        line-height: 1;
        text-shadow: 2px 2px 5px black;
    }
}

.priceBox {
    padding: 20px 5px 20px 5px;
    background: linear-gradient(0deg, rgba(0,0,0,0.8) 75%, rgba(0,0,0,0) 100%);
    width: 100%;

    &.playersChoice {
        padding-right: 50px;
    }

    .amount {
        color: #f5f5f5;
        font-size: 22px;

        &.stroke {
            color: gray;
            text-decoration: line-through;
        }

        &.discount {
            color: #00c200;
        }
    }
}

.description {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    //margin: 15px 30px 15px 0;
    background: rgba(0, 0, 0, 0.3);
    box-shadow: 0 0 5px 4px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    padding: 5px 0 5px 0;
    gap: 10px;
    max-width: 230px;
    backdrop-filter: blur(3px);
    margin: 0 20px 0 0;

    ul {
        //background: rgba(0, 0, 0, 0.6);
        //box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.9);
        border-radius: 5px;
        padding: 1px 10px 1px 10px;
        list-style: none;
        margin: 0;
        gap: 3px;
        display: flex;
        flex-direction: column;

        li {
            font-size: 14px;
            color: white;
            text-shadow: 0 0 6px black;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            text-align: center;
            align-items: center;
            gap: 5px;
            line-height: 1;

            //&::before {
            //    content: "\2022";
            //    text-shadow: 0 0 5px black;
            //    color: white;
            //    font-weight: bold;
            //    font-size: 12px;
            //    display: inline-block;
            //    text-align: center;
            //}

            .bonusIcon {
                width: 40px;
                height: 40px;

                &.avatar {
                    border-radius: 5px;
                }

                &.flipped {
                    transform: scaleX(-1);
                }
            }

            .bonus {
                display: flex;
                flex-direction: column;
                width: 100%;

                .name {
                    color: white;
                    text-align: center;
                }

                .type {
                    color: gray;
                }
            }
        }
    }
}

.label {
    max-width: 80px;
    color: #c4c4c4;
    text-shadow: 0 0 3px black;
    line-height: 1;
    font-size: 12px;
}

.passContainer {
    width: 150px;
}
</style>
